module.exports = __webpack_public_path__ + "img/lepanel-mockup.d3ce2a85.jpg";